module.exports = __webpack_public_path__ + "img/sv7on.2023a697.svg";